import React from 'react';
import { Dialog } from "primereact/dialog";
import GenericTable from "../SocioDemografia/GenericTable/GenericTable";
import DataTable from "./DataTable";
import GenericDataFormatter from "../SocioDemografia/GenericTable/GenericDataFormatter";
import LinkagesDataLayerService from "../../services/LinkagesDataLayer/LinkagesDataLayerService";
import getLabel from '../../services/LinkagesDataLayer/labels';
import { estados } from '../../util/estados';


class LinkagesDataTableModal extends React.Component {

    constructor(props) {
        super(props);
    }

    useGenericTable(datalayerName) {
        return [
            'populacao', 'domicilios', 'populacao_domicilios', 'renda_consumo',
            'renda', 'consumo', 'indice_propriedade', 'consumo_valor', 'consumo_porcentagem'
        ].includes(datalayerName);
    }

    render() {
        let formatter = null;

        const title = LinkagesDataLayerService.getLayerLabel(this.props.activeDatalayer);

        if (this.useGenericTable(this.props.activeDatalayer)) {
            const config = this.getFormatterConfig(title);
            formatter = new GenericDataFormatter(this.props.data, this.props.overlays, config);
        }

        const getExtraExportData = async () => {
            const { cidades = [] } = this.props.getTransformedPayload?.() || {};
            const uniqueUFs = [...new Set(cidades.map(c => c.uf).filter(Boolean))];
            if (!uniqueUFs.length) return {};

            const requestPayload = this.props.getTransformedPayload();
            const stateBase = { ...requestPayload, cidades: [], polygons: [], poligonos: [], field: null };

            const [stateResponses, brasilResponse] = await Promise.all([
                Promise.all(uniqueUFs.map(uf => LinkagesDataLayerService.getAggregatedData({ ...stateBase, estados: [uf] }))),
                LinkagesDataLayerService.getAggregatedData({ ...stateBase, estados: [], pais: true }),
            ]);

            const extraData = {};
            const extraHeaders = [];
            const extraKeys = [];

            stateResponses.forEach((res, idx) => {
                const uf = uniqueUFs[idx];
                const label = estados.find(e => e.value === uf)?.label || uf;
                const key = `__estado_${uf}`;
                extraKeys.push(key);
                extraHeaders.push(`Total ${label}`);
                extraData[key] = res.data || [];
            });

            extraKeys.push('__brasil');
            extraHeaders.push('Total Brasil');
            extraData['__brasil'] = brasilResponse.data || [];

            return { extraData, extraHeaders, extraKeys };
        };

        return (
            <React.Fragment>
                <Dialog header={title}
                    visible={this.props.visible}
                    style={{
                        width: '60vw',
                        marginTop: '30px'
                    }} onHide={this.props.onHide}>
                    <div className="card" style={{
                        maxHeight: '75vh',
                        minHeight: '50vh',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        marginBottom: '20px'
                    }}>
                        <div className="card-body" style={{ overflowX: 'scroll' }}>
                            {this.useGenericTable(this.props.activeDatalayer) && formatter && <React.Fragment>
                                <GenericTable
                                    formatter={formatter}
                                    overlays={this.props.overlays}
                                    getExtraExportData={getExtraExportData}
                                />
                            </React.Fragment>}

                            {!this.useGenericTable(this.props.activeDatalayer) && <React.Fragment>
                                <DataTable
                                    data={this.props.data}
                                    activeDatalayer={this.props.activeDatalayer}
                                />
                            </React.Fragment>}
                        </div>
                    </div>
                </Dialog>
            </React.Fragment>
        );
    }

    getFormatterConfig(title) {
        const config = {
            dados: {},
            data_label: "",
            title: title,
            uses_subheader: true,
            hide_percentage: false,
            datalayerName: this.props.activeDatalayer
        }

        if (this.props.data && this.props.data.length > 0) {
            const camposRenda = ['pib_per_capita', 'pib', 'renda_media_domiciliar', 'nr_salario_minimo_mensal_por_domicilio'];
            const isRenda = this.props.activeDatalayer === 'renda';

            const campos = isRenda ? camposRenda : Object.keys(this.props.data[0]).filter(k => k !== 'shape_id' && k !== 'nome');

            campos.forEach((datum) => {
                config.dados[datum] = getLabel(datum);
            });
        }


        return config;
    }
}

export default LinkagesDataTableModal;
